import { bindContent } from "../content/catalog"

/**
 * The items that build a solid BLOCK wall material (autotile_wall.ts `block`), as the content's wall definitions say.
 * A leaf (only the content binding): the tile map provider, the house builder and placement all ask it, and the
 * autotile library imports too much to be imported by them all.
 */
let blockItems = new Set<string>()

/** Every item a block definition names, from a definitions file's entries. */
export const blockWallItemsOf = (definitions: readonly any[] = []): Set<string> =>
    new Set(definitions.filter(d => d?.kind === "wall" && d.block === true && typeof d.itemType === "string").map(d => d.itemType as string))

bindContent(catalog => blockWallItemsOf((catalog.source?.autotiles as any)?.definitions), next => { blockItems = next })

/** Whether `itemType` builds a solid block: filled like a floor, blocking like a wall. */
export const isBlockWallItem = (itemType: string | undefined): boolean => !!itemType && blockItems.has(itemType)
